export default __webpack_public_path__ + "static/media/Edit.cead91ce.svg";